import { render, staticRenderFns } from "./app-root.vue?vue&type=template&id=232aeb39&scoped=true&"
import script from "./app-root.vue?vue&type=script&lang=js&"
export * from "./app-root.vue?vue&type=script&lang=js&"
import style0 from "./app-root.vue?vue&type=style&index=0&id=232aeb39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232aeb39",
  null
  
)

component.options.__file = "app-root.vue"
export default component.exports